import { createSlice } from '@reduxjs/toolkit';
const gridDrawerSlice = createSlice({
  name: 'gridDrawer',
  initialState: [],
  //NOTE filtersTYPE=[ {checkMode:"all",filtersMode:[ {column:"HI" , mode: "contains" , value: "helloworld"},... ]} , ... ]
  reducers: {
    addGridDrawer: (state, { payload }) => {
      const { data, columns } = payload;
      state.push({ title: 'test', field: 'test', data, columns });
    },
    closeGridDrawer: state => {
      state.pop();
    }
  }
});
export const { closeGridDrawer, addGridDrawer } = gridDrawerSlice.actions;
// export const NonFilterBacklink = gridDrawerSlice.getInitialState();
export default gridDrawerSlice;
